/*	Copyright (c) 2016 Jean-Marc VIGLINO,
	released under the CeCILL-B license (French BSD license)
	(http://www.cecill.info/licences/Licence_CeCILL-B_V1-en.txt).
*/

import ol_ext_inherits from 'ol-ext/util/ext'
import ol_control_Toggle from 'ol-ext/control/Toggle'
import ol_interaction_Draw from 'ol/interaction/Draw'
import ol_style_Style from 'ol/style/Style'
import ol_style_Fill from 'ol/style/Fill'
import ol_style_Stroke from 'ol/style/Stroke'
import ol_style_Circle from 'ol/style/Circle'
import Overlay from 'ol/Overlay';
import {getArea as ol_sphere_getArea} from 'ol/sphere'
import {unByKey} from 'ol/Observable';



/** A simple toggle control
 * The control can be created with an interaction to control its activation.
 *
 * @constructor
 * @extends {ol_control_Control}
 * @fires change:active, change:disable
 * @param {Object=} options Control options.
 *	@param {String} options.className class of the control
 *	@param {String} options.title title of the control
 *	@param {String} options.html html to insert in the control
 *	@param {ol.interaction} options.interaction interaction associated with the control
 *	@param {bool} options.active the control is created active, default false
 *	@param {bool} options.disable the control is created disabled, default false
 *	@param {ol.control.Bar} options.bar a subbar associated with the control (drawn when active if control is nested in a ol.control.Bar)
 *	@param {bool} options.autoActive the control will activate when shown in an ol.control.Bar, default false
 *	@param {function} options.onToggle callback when control is clicked (or use change:active event)
 */
var ol_control_MeasureArea = function (options) {
     options = options || {};

    this.source = options.source;
    if (options.source) {
        
        options.interaction = this.createInteraction(options.source)
    }
    options.title = options.title || "Fläche messen";
    options.html = (options.html || "<span class='icon'></span>");
    options.className = (options.className || "") + " ol-measure-area";
    this.sphere = true;//options.hasOwnProperty("sphere") ? options["sphere"] : false;
    /**
     * Currently drawn feature.
     * @type {module:ol/Feature~Feature}
     */
    this.sketch;


    /**
     * The help tooltip element.
     * @type {Element}
     */
    this.helpTooltipElement;


    /**
     * Overlay to show the help messages.
     * @type {module:ol/Overlay}
     */
    this.helpTooltip;


    /**
     * The measure tooltip element.
     * @type {Element}
     */
    this.measureTooltipElement;


    /**
     * Overlay to show the measurement.
     * @type {module:ol/Overlay}
     */
    this.measureTooltip;

    this.geometryListener;

    this.draw;
//    this.map2;

    /**
     * Message to show when the user is drawing a line.
     * @type {string}
     */
    this.continueLineMsg = 'Klicken Sie, um mit dem Zeichnen des Polygons fortzufahren';

    this.geometryListenerBind = this.geometryListener.bind(this)
    this.pointerMoveHandlerBind = this.pointerMoveHandler.bind(this)
    this.mouseoutBind = this.mouseout.bind(this)
    ol_control_Toggle.call(this, options);
   
    
};
ol_ext_inherits(ol_control_MeasureArea, ol_control_Toggle);

ol_control_MeasureArea.prototype.createInteraction = function (source) {
    this.draw = new ol_interaction_Draw({
        source: source,
        type: 'Polygon',
        style: new ol_style_Style({
            fill: new ol_style_Fill({
                color: 'rgba(255, 255, 255, 0.2)'
            }),
            stroke: new ol_style_Stroke({
                color: 'rgba(0, 0, 0, 0.5)',
                lineDash: [10, 10],
                width: 2
            }),
            image: new ol_style_Circle({
                radius: 5,
                stroke: new ol_style_Stroke({
                    color: 'rgba(0, 0, 0, 0.7)'
                }),
                fill: new ol_style_Fill({
                    color: 'rgba(255, 255, 255, 0.2)'
                })
            })
        })
    });
    
    this.draw.on('drawstart', (evt) => {
        this.createMeasureTooltip();
        this.source.clear();
        // set sketch
        this.sketch = evt.feature;

        /** @type {module:ol/coordinate~Coordinate|undefined} */
        var tooltipCoord = evt.coordinate;

        this.geometryListenerKey = this.sketch.getGeometry().on('change', this.geometryListenerBind);
    });

    this.draw.on('drawend', () => {
        unByKey(this.geometryListenerKey)
        //this.sketch.getGeometry().un(this.geometryListenerBind);
        this.measureTooltipElement.className = 'oltooltip oltooltip-static';
        this.measureTooltip.setOffset([0, -7]);
        // unset sketch
        this.sketch = null;
        // unset tooltip so that a new one can be created
        //this.measureTooltipElement = null;


    }, this);
    
    return this.draw;
}

/** Set spurce for interaction 
 * @param {_ol_sourcen_} s source to associate with the control
 */
ol_control_MeasureArea.prototype.setSource = function (s) {

    if (s) {
        ol_control_Toggle.prototype.setInteraction.call(this, this.createInteraction(s));
    }
};


ol_control_MeasureArea.prototype.setActive = function (b) {

    if (this.getActive() === b) {
        return;
    }
    ol_control_Toggle.prototype.setActive.call(this, b);


    var map = this.getMap();

    if (map) {
        if (b) {
            this.createHelpTooltip();
            map.on('pointermove', this.pointerMoveHandlerBind);
            map.getViewport().addEventListener('mouseout', this.mouseoutBind);
             
        } else {
            map.un('pointermove', this.pointerMoveHandlerBind);
            map.getViewport().removeEventListener('mouseout', this.mouseoutBind);
            
            if (this.helpTooltipElement) {
                this.getMap().removeOverlay(this.helpTooltip);
                if(this.helpTooltipElement.parentNode) {
                    this.helpTooltipElement.parentNode.removeChild(this.helpTooltipElement);
                }
                this.helpTooltipElement = null;
                this.helpTooltip = null;
            }
            if (this.measureTooltipElement) {
                this.getMap().removeOverlay(this.measureTooltip);
                if(this.measureTooltipElement.parentNode) {
                   this.measureTooltipElement.parentNode.removeChild(this.measureTooltipElement);
                }
                this.measureTooltipElement = null;
                this.measureTooltip=null;
            }
            this.source.clear();
        }

        


    }


}


ol_control_MeasureArea.prototype.geometryListener = function (evt) {
    var geom = evt.target;
    var output,tooltipCoord;

    output = this.formatArea(geom);
    tooltipCoord =  geom.getInteriorPoint().getCoordinates();

    this.measureTooltipElement.innerHTML = output;
    this.measureTooltip.setPosition(tooltipCoord);
}

ol_control_MeasureArea.prototype.mouseout = function () {
    this.helpTooltipElement.classList.add('hidden');
}





/**
 * Creates a new measure tooltip
 */
ol_control_MeasureArea.prototype.createMeasureTooltip = function () {
    if (this.measureTooltipElement) {
        this.getMap().removeOverlay(this.measureTooltip);
        this.measureTooltipElement.parentNode.removeChild(this.measureTooltipElement);
    }
    this.measureTooltipElement = document.createElement('div');
    this.measureTooltipElement.className = 'oltooltip oltooltip-measure';
    this.measureTooltip = new Overlay({
        element: this.measureTooltipElement,
        offset: [0, -15],
        positioning: 'bottom-center'
    });
    this.getMap().addOverlay(this.measureTooltip);
}

/**
 * Creates a new help tooltip
 */
ol_control_MeasureArea.prototype.createHelpTooltip = function () {
    if (this.helpTooltipElement) {
        this.getMap().removeOverlay(this.helpTooltip);
        this.helpTooltipElement.parentNode.removeChild(this.helpTooltipElement);
        
    }
    this.helpTooltipElement = document.createElement('div');
    this.helpTooltipElement.className = 'oltooltip hidden';
    this.helpTooltip = new Overlay({
        element: this.helpTooltipElement,
        offset: [15, 0],
        positioning: 'center-left'
    });
    this.getMap().addOverlay(this.helpTooltip);
}



/**
 * Handle pointer move.
 * @param {module:ol/MapBrowserEvent~MapBrowserEvent} evt The event.
 */
ol_control_MeasureArea.prototype.pointerMoveHandler = function (evt) {
    if (evt.dragging) {
        return;
    }
    /** @type {string} */
    var helpMsg = 'Klicken Sie, um mit dem Zeichnen zu beginnen';

    if (this.sketch) {
        helpMsg = this.continueLineMsg;
    }

    this.helpTooltipElement.innerHTML = helpMsg;
    this.helpTooltip.setPosition(evt.coordinate);

    this.helpTooltipElement.classList.remove('hidden');
};

 /**
   * Format area output.
   * @param {module:ol/geom/Polygon~Polygon} polygon The polygon.
   * @return {string}                         Formatted area.
   */
ol_control_MeasureArea.prototype.formatArea = function (polygon) {
        var area = null;
	if(this.sphere) {
		area = ol_sphere_getArea(polygon);
	}else {
		area = polygon.getArea();
	}
    
    var output;
    if (area >= 1000000) {
      output = (Math.round(area / 1000000 * 100) / 100) +
          ' ' + 'km<sup>2</sup>';
    } else {
      output = (Math.round(area * 100) / 100) +
          ' ' + 'm<sup>2</sup>';
    }
    return output;
};

export default ol_control_MeasureArea